import { useMemo } from 'react';

type Language = 'pl' | 'ua';

interface Translations {
  stats: string;
  achievements: string;
  darkMode: string;
  sound: string;
  language: string;
  ukrainian: string;
  polish: string;
  time: string;
  score: string;
  hints: string;
  start: string;
  pause: string;
  validate: string;
  hint: string;
  newGame: string;
  gamesPlayed: string;
  winRate: string;
  bestTime: string;
  hintsUsed: string;
  description: string;
  chooseDifficulty: string;
  correct: string;
  incorrect: string;
  congratulations: string;
  puzzleSolved: string;
  playAgain: string;
  menu: string;
}

const translations: Record<Language, Translations> = {
  pl: {
    stats: 'Statystyki',
    achievements: 'Osiągnięcia',
    darkMode: 'Tryb ciemny',
    sound: 'Dźwięk',
    language: 'Język',
    ukrainian: 'Ukraiński',
    polish: 'Polski',
    time: 'Czas',
    score: 'Wynik',
    hints: 'Podpowiedzi',
    start: '▶ Start',
    pause: '⏸ Pauza',
    validate: '✓ Sprawdź',
    hint: '💡 Podpowiedź',
    newGame: 'Nowa gra',
    gamesPlayed: 'Rozegrane gry',
    winRate: 'Współczynnik wygranych',
    bestTime: 'Najlepszy czas',
    hintsUsed: 'Użyte podpowiedzi',
    description: 'Opis',
    chooseDifficulty: 'Wybierz poziom trudności',
    correct: '✅ Poprawnie!',
    incorrect: '❌ Nieprawidłowo. Spróbuj ponownie!',
    congratulations: 'Gratulacje!',
    puzzleSolved: 'Puzzle rozwiązane!',
    playAgain: 'Zagraj ponownie',
    menu: 'Menu',
  },
  ua: {
    stats: 'Статистика',
    achievements: 'Досягнення',
    darkMode: 'Темний режим',
    sound: 'Звук',
    language: 'Мова',
    ukrainian: 'Українська',
    polish: 'Польська',
    time: 'Час',
    score: 'Бали',
    hints: 'Підказки',
    start: '▶ Старт',
    pause: '⏸ Пауза',
    validate: '✓ Перевірити',
    hint: '💡 Підказка',
    newGame: 'Нова гра',
    gamesPlayed: 'Зіграно ігор',
    winRate: 'Відсоток перемог',
    bestTime: 'Найкращий час',
    hintsUsed: 'Використані підказки',
    description: 'Опис',
    chooseDifficulty: 'Оберіть рівень складності',
    correct: '✅ Правильно!',
    incorrect: '❌ Неправильно. Спробуйте ще раз!',
    congratulations: 'Вітаємо!',
    puzzleSolved: 'Головоломка розв\'язана!',
    playAgain: 'Грати знову',
    menu: 'Меню',
  }
};

export function useTranslations(language: Language) {
  const t = useMemo(() => translations[language], [language]);
  return t;
}
